import SecondaryButton from "components/buttons/SecondaryButton";
import {
  TransportSedel,
  TransportSedelStatus,
} from "types/transportSedel.type";
import { SignaturePreview } from "./SignaturePreview";
import { useSignatureModalLogic } from "./useSignatureModalLogic";
import { SignatureModal } from "./SignatureModal";
import {
  Item as ListItem,
  Label,
  Value,
} from "components/multiColumnList/MultiColumnList";
import PrimaryButton from "components/buttons/PrimaryButton";
import { Info } from "components/Info";
import { Uppdrag } from "types/uppdrag.type";

const MISSING_DRIVER_TEXT =
  "Tillgänglig när en chaufför är kopplad till uppdraget";

type Props = {
  transportSedel: TransportSedel;
  uppdrag: Uppdrag;
};
export const SignatureSection = ({ transportSedel, uppdrag }: Props) => {
  const isMissingDriver = !uppdrag.assignedToUser;

  return (
    <>
      {/* <h4 className="mb-2 flex items-center justify-between text-sm font-semibold text-gray-900">
        Signaturer
      </h4> */}
      <Item
        label="Signatur chaufför"
        transportSedel={transportSedel}
        fieldName="driverSignature"
        isDisabled={isMissingDriver}
        disabledText={MISSING_DRIVER_TEXT}
      />
      <Item
        label="Signatur lämnare"
        transportSedel={transportSedel}
        fieldName="customerSignature"
        notAvailableFieldName="customerSignatureUnavailable"
      />

      <Item
        label="Signatur mottagare"
        transportSedel={transportSedel}
        fieldName="wasteStationSignature"
        notAvailableFieldName="wasteStationSignatureUnavailable"
        isDisabled={transportSedel.status === TransportSedelStatus.Created}
        disabledText="Tillgänglig när transportdokumentet är Lastat"
      />
    </>
  );
};

type ItemProps = {
  label: string;
  transportSedel: TransportSedel;
  fieldName: keyof TransportSedel;
  notAvailableFieldName?: keyof TransportSedel;
  isDisabled?: boolean;
  disabledText?: string;
};
const Item = ({
  label,
  transportSedel,
  fieldName,
  notAvailableFieldName,
  isDisabled,
  disabledText,
}: ItemProps) => {
  const logic = useSignatureModalLogic(
    transportSedel,
    fieldName,
    notAvailableFieldName,
  );

  const isNotAvailable =
    !!notAvailableFieldName && !!transportSedel[notAvailableFieldName];

  if (isDisabled) {
    return (
      <ListItem>
        <Label>{label}</Label>
        <Value>
          <Info text={disabledText!} />
        </Value>
      </ListItem>
    );
  }

  return (
    <ListItem>
      <Label>{label}</Label>
      <Value className="flex justify-start">
        <SignaturePreview
          signature={transportSedel[fieldName] as string | undefined | null}
          className="mr-4 mt-1 h-6"
        />
        {notAvailableFieldName && transportSedel[notAvailableFieldName] && (
          <span className="mr-1 inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
            Ej tillgänglig
          </span>
        )}
        <div className="flex items-center">
          {transportSedel[fieldName] || isNotAvailable ? (
            <SecondaryButton size="small" onClick={logic.openModal}>
              Ändra
            </SecondaryButton>
          ) : (
            <PrimaryButton
              // color="primarySoft"
              size="small"
              onClick={logic.openModal}
            >
              Signera
            </PrimaryButton>
          )}

          {notAvailableFieldName &&
            !transportSedel[fieldName] &&
            !transportSedel[notAvailableFieldName] && (
              <SecondaryButton
                // color="errorSoft"
                size="small"
                onClick={logic.onNotAvailableSubmit}
                className="ml-2"
              >
                Ej tillgänglig
              </SecondaryButton>
            )}
        </div>

        <SignatureModal
          isOpen={logic.isModalOpen}
          title={label}
          onClose={logic.closeModal}
          onSubmit={logic.onSubmit}
          isPending={logic.isPending}
          existingSignatureInBase64={
            transportSedel[fieldName] as string | undefined | null
          }
        />
      </Value>
    </ListItem>
  );
};
